import React, { useState, useCallback } from "react";
import { ListGroup, ListGroupItem } from "components/bootstrap";
import BootstrapModalForm from "components/bootstrap/BootstrapModalForm";
import Input from "components/bootstrap/Input";
import QueryTitle from "views/logic/queries/QueryTitle";
import useQueryIds from "views/hooks/useQueryIds";
import useActiveQueryId from "views/hooks/useActiveQueryId";
const _tabList = (view, queryIds) => queryIds.map((queryId) => {
  const tabTitle = QueryTitle(view, queryId) || "Unknown Page title";
  return { id: queryId, name: tabTitle };
});
const MoveWidgetToTabModal = ({ view, onCancel, onSubmit, widgetId }) => {
  const [selectedTab, setSelectedTab] = useState(null);
  const [keepCopy, setKeepCopy] = useState(false);
  const activeQuery = useActiveQueryId();
  const queryIds = useQueryIds();
  const onKeepCopy = useCallback((e) => setKeepCopy(e.target.checked), [setKeepCopy]);
  const submit = useCallback(
    () => onSubmit(widgetId, selectedTab, keepCopy),
    [onSubmit, widgetId, selectedTab, keepCopy]
  );
  const list = _tabList(view, queryIds.toArray()).filter(({ id }) => id !== activeQuery);
  const tabList = list.map(({ id, name }) => /* @__PURE__ */ React.createElement(ListGroupItem, { onClick: () => setSelectedTab(id), active: id === selectedTab, key: id }, name));
  const renderResult = list && list.length > 0 ? /* @__PURE__ */ React.createElement(ListGroup, null, tabList) : /* @__PURE__ */ React.createElement("span", null, "No pages found");
  return /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show: true,
      onCancel,
      submitButtonDisabled: !selectedTab,
      submitButtonText: `${keepCopy ? "Copy" : "Move"} widget`,
      onSubmitForm: submit,
      title: "Choose Target Page"
    },
    renderResult,
    /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "checkbox",
        id: "keepCopy",
        name: "keepCopy",
        label: "Keep Copy on this Page",
        onChange: onKeepCopy,
        help: "When 'Keep Copy on the Page' is enabled, the widget will be copied and not moved to another page",
        checked: keepCopy
      }
    )
  );
};
export default MoveWidgetToTabModal;
